// Markdown rendering module for ChatWidget

// Escape HTML to prevent XSS
export function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML.replace(/\n/g, '<br>');
}

// Render markdown text to HTML
export function renderMarkdown(text) {
    // Convert special link markers to buttons BEFORE escaping HTML
    // XML-style format: <VEHICLELINK url="..." /> or <LINK url="..." label="..." />
    const linkButtons = [];

    // Match <OPTION index="..." label="..." /> format for multi-option buttons
    // Note: These are stripped out and will be rendered separately as compact buttons below the message
    text = text.replace(/<OPTION\s+index=["'](\d+)["']\s+label=["']([^"']+)["']\s*\/?>/gi, '');

    // Match <VEHICLELINK url="..." /> - simple format, just the URL
    // Supports both absolute URLs (https://...) and relative paths (/...)
    text = text.replace(/<VEHICLELINK\s+url=["']([^"']+)["']\s*\/?>/gi, (match, url) => {
        url = url.trim(); // Clean captured URL
        const placeholder = `___LINKBTN_${linkButtons.length}___`;
        linkButtons.push(`<a href="${url}" class="vehicle-link-btn">Details</a>`);
        return placeholder;
    });

    // Also support the LINK format with custom labels
    // Format: <LINK url="..." label="..." />
    text = text.replace(/<LINK\s+url=["']([^"']+)["']\s+label=["']([^"']+)["']\s*\/?>/gi, (match, url, label) => {
        url = url.trim();     // Clean captured URL
        label = label.trim(); // Clean captured label
        const placeholder = `___LINKBTN_${linkButtons.length}___`;
        linkButtons.push(`<a href="${url}" class="vehicle-link-btn">${label}</a>`);
        return placeholder;
    });

    // First, extract and protect any button HTML that the LLM might generate
    const buttons = [];
    text = text.replace(/<button[^>]*onclick="window\.open\('([^']+)'[^>]*>([^<]+)<\/button>/gi, (match, url, label) => {
        const placeholder = `___BTN_${buttons.length}___`;
        buttons.push(`<a href="${url}" target="_blank" rel="noopener noreferrer" class="vehicle-link-btn">${label}</a>`);
        return placeholder;
    });

    // Also handle simpler button format: <button onclick="window.open('url')">text</button>
    text = text.replace(/<button[^>]*onclick=["']window\.open\(["']([^"']+)["']\)[^>]*>([^<]+)<\/button>/gi, (match, url, label) => {
        const placeholder = `___BTN_${buttons.length}___`;
        buttons.push(`<a href="${url}" target="_blank" rel="noopener noreferrer" class="vehicle-link-btn">${label}</a>`);
        return placeholder;
    });

    // Escape HTML
    const div = document.createElement('div');
    div.textContent = text;
    let html = div.innerHTML;

    // Restore link buttons
    linkButtons.forEach((btn, index) => {
        html = html.replace(`___LINKBTN_${index}___`, btn);
    });

    // Restore buttons (they're already safe HTML)
    buttons.forEach((btn, index) => {
        html = html.replace(`___BTN_${index}___`, btn);
    });

    // Code blocks (``` or ~~~ fenced)
    html = html.replace(/```(\w+)?\n([\s\S]*?)```/g, (match, lang, code) => {
        return `<pre><code>${code.trim()}</code></pre>`;
    });
    html = html.replace(/~~~(\w+)?\n([\s\S]*?)~~~/g, (match, lang, code) => {
        return `<pre><code>${code.trim()}</code></pre>`;
    });

    // Inline code
    html = html.replace(/`([^`]+)`/g, '<code>$1</code>');

    // Bold
    html = html.replace(/\*\*([^\*]+)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/__([^_]+)__/g, '<strong>$1</strong>');

    // Italic
    html = html.replace(/\*([^\*]+)\*/g, '<em>$1</em>');
    html = html.replace(/_([^_]+)_/g, '<em>$1</em>');

    // Markdown links (must come before plain URL detection)
    // First, temporarily replace markdown links with placeholders to protect them
    const markdownLinks = [];
    html = html.replace(/\[([^\]]+)\]\(([^\)]+)\)/g, (match, text, url) => {
        const placeholder = `___MDLINK_${markdownLinks.length}___`;
        markdownLinks.push(`<a href="${url}" target="_blank" rel="noopener noreferrer">${text}</a>`);
        return placeholder;
    });

    // TEMPORARILY DISABLED - Auto-detect and linkify plain URLs (http, https, www)
    // Now we can safely linkify without worrying about markdown links
    // html = html.replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
    // html = html.replace(/(www\.[^\s<]+)/g, '<a href="http://$1" target="_blank" rel="noopener noreferrer">$1</a>');

    // Restore markdown links from placeholders
    markdownLinks.forEach((link, index) => {
        html = html.replace(`___MDLINK_${index}___`, link);
    });

    // Line breaks
    html = html.replace(/\n/g, '<br>');

    return html;
}
